import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";
import { useAuth } from "api/auth";

type ResetPasswordPayload = {
  email: string;
  oldPassword: string;
  newPassword: string;
};

type ResetPasswordResponse = {
  message: string;
};

const resetPassword = async (
  payload: ResetPasswordPayload
): Promise<ResetPasswordResponse> => {
  const { data } = await customAxios.post<ResetPasswordResponse>(
    "/users/reset-password",
    payload
  );
  return data;
};

export const useResetPassword = () => {
  const { logout } = useAuth();
  return useMutation<ResetPasswordResponse, AxiosError, ResetPasswordPayload>({
    mutationFn: resetPassword,

    onSuccess: (data) => {
      showNotification({
        title: "Success",
        message: data.message || "Password updated successfully.",
        color: "green",
      });
      setTimeout(() => {
        logout();
        window.location.reload();
      }, 1000);
    },

    onError: (error) => {
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ||
          "Password reset failed",
        color: "red",
      });
    },
  });
};
